import React, { useContext } from 'react';
import { ProductContext } from '../../App';

function RoleComponent(props) {
    const product_context = useContext(ProductContext);
    const { user } = product_context;

    if (user?.role === props?.role) {
        return <>
            {props.children}
        </>
    }
}

export default RoleComponent
